/* eslint-disable import/prefer-default-export */
import axios from 'axios'

// download All document
export const downloaAllDocRL = (id, requestNumber, requestType) => axios.get(`file/shipment/download/all/stream/${id}/${requestNumber}/${requestType}`, { responseType: 'blob' })
  .then((res) => {
    const blob = new Blob([res.data], { type: res.headers['content-type'] })
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = `Document_${requestNumber}.zip`
    document.body.appendChild(link)
    link.click()
    return res
  })
  .catch((err) => {
    throw err.response
  })



// WEBPACK FOOTER //
// ./src/api/requestlist.api.js